import { apiClient } from './client';
import type { PaginatedResponse } from '../types/api';
import type {
  ClaimCreateTestPayload,
  ClaimDetail,
  ClaimListItem,
  ClaimNotification,
  ClaimUser,
} from '../types/claims';

const BASE = '/claims/';

export const claimsApi = {
  list: (params?: { status?: string; page?: number; page_size?: number; search?: string }) =>
    apiClient.get<PaginatedResponse<ClaimListItem>>(BASE, { params }).then((r) => r.data),

  get: (id: number) => apiClient.get<ClaimDetail>(`${BASE}${id}/`).then((r) => r.data),

  unreadCount: () =>
    apiClient.get<{ count: number }>(`${BASE}unread-count/`).then((r) => r.data.count),

  close: (id: number, resolution_comment: string) =>
    apiClient.post<ClaimDetail>(`${BASE}${id}/close/`, { resolution_comment }).then((r) => r.data),

  createTest: (payload: ClaimCreateTestPayload) =>
    apiClient.post<ClaimDetail>(`${BASE}create-test/`, payload).then((r) => r.data),

  comment: (id: number, body: string, assigned_to_next: number[]) =>
    apiClient
      .post<ClaimDetail>(`${BASE}${id}/comment/`, {
        body,
        assigned_to_next: assigned_to_next.length > 0 ? assigned_to_next : undefined,
      })
      .then((r) => r.data),

  users: () => apiClient.get<ClaimUser[]>(`${BASE}users/`).then((r) => r.data),

  myNotifications: () =>
    apiClient.get<ClaimNotification[]>(`${BASE}my-notifications/`).then((r) => r.data),

  markNotificationRead: (id: number) =>
    apiClient
      .post<{ id: number; read_at: string }>(`${BASE}notifications/${id}/read/`)
      .then((r) => r.data),
};
